import React from 'react';

function textColor(bg) {
  if (!bg || bg.length < 7) return '#fff';
  const r = parseInt(bg.slice(1, 3), 16);
  const g = parseInt(bg.slice(3, 5), 16);
  const b = parseInt(bg.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? 'var(--text)' : '#fff';
}

export default function TagBadge({ tag, onRemove, size = 'sm', style }) {
  if (!tag) return null;
  const bg = tag.color || '#6B7686';
  const fg = textColor(bg);
  const padding = size === 'sm' ? '2px 8px' : '4px 12px';
  const fontSize = size === 'sm' ? 11 : 13;
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        background: bg, color: fg,
        padding, borderRadius: 999, fontSize, fontWeight: 500,
        lineHeight: 1.4, ...style,
      }}
    >
      {tag.name}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onRemove(tag); }}
          style={{
            background: 'transparent', border: 'none', color: fg,
            cursor: 'pointer', padding: 0, fontSize: fontSize + 1, lineHeight: 1,
            opacity: 0.75,
          }}
          aria-label={`إزالة ${tag.name}`}
        >×</button>
      )}
    </span>
  );
}

export function TagList({ tags, onRemove, size = 'sm', style }) {
  if (!tags || tags.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, ...style }}>
      {tags.map(t => <TagBadge key={t.id} tag={t} onRemove={onRemove} size={size} />)}
    </div>
  );
}
